import { DateTime } from 'luxon';

export function getSessionInterval(date, timeCET = '09:00-10:00') {
  const [startTime, endTime] = (timeCET || '09:00-10:00').split('-');
  const start = DateTime.fromFormat(
    `${date || '01-01-1970'} ${startTime.trim()}`,
    'dd-MM-yyyy HH:mm',
    { zone: 'Europe/Paris' }
  );
  let end = endTime
    ? DateTime.fromFormat(
      `${date || '01-01-1970'} ${endTime.trim()}`,
      'dd-MM-yyyy HH:mm',
      { zone: 'Europe/Paris' }
    )
    : start.plus({ minutes: 60 });
  if (end < start) end = end.plus({ days: 1 });
  return { start, end };
}